export default __webpack_public_path__ + "static/media/eth-text.dec13ada.svg";